import React from 'react';

import { Box } from '@components/Restyle';
import { useHover } from '@hooks/useHover';
import theme from '@themes/theme';

export const WebHoverBox = ({
  children,
  backgroundColor = 'white' as keyof typeof theme.colors,
  hoverBackgroundColor = 'grey01' as keyof typeof theme.colors,
  ...props
}) => {
  // Canonical hover behaviour (TA-9005). `useHover` is web-only and returns no
  // handlers on native, so no Platform guard is needed here.
  const { isHovered: hovered, hoverProps } = useHover();

  const currentBackground = hovered ? hoverBackgroundColor : backgroundColor;

  return (
    <Box
      {...props}
      {...hoverProps}
      backgroundColor={currentBackground}
      style={{ cursor: 'pointer' }}>
      {typeof children === 'function' ? children({ hovered }) : children}
    </Box>
  );
};
